import {ThemeOptions} from '@mui/material/styles';
import {colorPalette, mainColor} from '@jobseeker/lotus/foundations';
import type {Theme} from '@mui/material';
import typography from './typography';
const shadows = new Array<string>(30)
  .fill('0px 6.48px 6px 2px rgba(41, 41, 41, 0.02)')
  .map(
    (p, i) => `0px ${6 + 2 * i}px ${6 + 2 * i}px 2px rgba(41, 41, 41, 0.02)`
  );

export const defaultTheme: Partial<ThemeOptions> | any = {
  palette: {
    error: {
      main: colorPalette.error['A500'],
    },
    primary: {
      main: colorPalette.green['A300'],
      contrastText: colorPalette.white['A50'],
    },
    secondary: {
      main: colorPalette.black['A300'],
      contrastText: colorPalette.white['A50'],
      dark: colorPalette.black['A600'],
    },
    text: {
      primary: mainColor.black,
      secondary: colorPalette.black['A100'],
      disabled: colorPalette.white['A125'],
    },
    gray: {
      main: colorPalette.white['A100'],
      dark: colorPalette.black['A100'],
    },
    dustGreen: {
      light: colorPalette.dustGreen['A300'],
      main: colorPalette.dustGreen['A400'],
      dark: colorPalette.dustGreen['A500'],
    },
    prompt: {
      light: colorPalette.prompt['A100'],
      main: colorPalette.prompt['A200'],
      dark: colorPalette.prompt['A300'],
    },
    blue: {
      lightNavy: colorPalette.blue['A100'],
    },
    border: {
      main: '#F3F7FA',
      light: '#91B879',
      dark: '#F3F7FA',
      lightGray: '#7E7E7E33',
      green: '#91B879',
      darkGreen: '#49966E',
    },
    pro: {
      main: 'linear-gradient(180deg, #FFB743 0%, #F99914 100%)',
      light: 'linear-gradient(180deg, #FFB743 0%, #F99914 100%)',
      dark: 'linear-gradient(180deg, #FFB743 0%, #F99914 100%)',
    },
  },
  breakpoints: {
    values: {
      xxs: 0,
      xs: 350,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1440,
      xxl: 1536,
    },
  },
  typography,
  shadows: ['none', ...shadows],
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          subtitle2: 'p',
        },
      },
    },
  },
};

export const getRandomColor = (id: number | undefined = undefined) => {
  const colorCollection = [
    '#75ce93',
    '#459bd0',
    '#b4b9d8',
    '#f2998f',
    '#a877e8',
    '#4fb6ac',
  ];
  if (id === undefined)
    id = Math.floor(Math.random() * colorCollection.length - 1);
  if (parseInt(id.toString()) > 9) {
    const _id = id.toString();
    id = parseInt(_id[_id.length - 1]);
  }
  if (id > colorCollection.length) {
    id = id - colorCollection.length;
  }

  // if (!id) {
  //   id = Math.floor(Math.random() * colorCollection.length - 1);
  // }
  // console.log("🚀 ~ file: index.ts:90 ~ getRandomColor ~ id:", id)
  return colorCollection[id] || colorCollection[0];
};

export {Theme};
